export class User {
  id: number
  login: string
  fullName: string
  phone: string | null
  permissions: Array<any>
  companyBillingId: number | null
  active: boolean
  alias: string
  forcePasswordReset: boolean
  pioneer: boolean
  apiToken: string | null
  integrationUser: boolean
  integrationDescription: string
  integrationEmailContact: string
  integrationFranchise: number | null
  integrationExpirationDate: Date | null
  preferredAuth: string | null
  emailStatus: string
  cpf: string | null

  constructor(option?: Partial<User>) {
    this.id = option?.id ?? 0
    this.login = option?.login ?? ''
    this.fullName = option?.fullName ?? ''
    this.phone = option?.phone ?? null
    this.permissions = option?.permissions ?? new Array()
    this.companyBillingId = option?.companyBillingId ?? null
    this.active = option?.active ?? true
    this.alias = option?.alias ?? ''
    this.forcePasswordReset = option?.forcePasswordReset ?? false
    this.pioneer = option?.pioneer ?? false
    this.apiToken = option?.apiToken ?? null
    this.integrationUser = option?.integrationUser ?? false
    this.integrationDescription = option?.integrationDescription ?? ''
    this.integrationEmailContact = option?.integrationEmailContact ?? ''
    this.integrationFranchise = option?.integrationFranchise ?? null
    this.integrationExpirationDate = option?.integrationExpirationDate ? new Date(option.integrationExpirationDate) : null
    this.preferredAuth = option?.preferredAuth ?? null
    this.emailStatus = option?.emailStatus ?? ''
    this.cpf = option?.cpf ?? null
  }
}
